import React, { ReactNode } from 'react';

import { FormFieldset } from './styles';

interface FieldsetProps {
    children: ReactNode;
    role?: string;
    className?: string;
    ariaInvalid?: boolean;
    ariaDescribedBy?: string;
}

const Fieldset = ({ children, role, className, ariaInvalid, ariaDescribedBy }: FieldsetProps) => {
    return (
        <FormFieldset
            role={role}
            className={className}
            aria-invalid={ariaInvalid}
            aria-describedby={ariaDescribedBy}
        >
            {children}
        </FormFieldset>
    );
};

export default Fieldset;
